export const ESTIMATED_BUDGET = [
	{ label: '₱0 - ₱10,000', value: '₱0 - ₱10,000' },
	{ label: '₱11,000 - ₱20,000', value: '₱11,000 - ₱20,000' },
	{ label: '₱21,000 - ₱30,000', value: '₱21,000 - ₱30,000' },
	{ label: '₱31,000 - ₱40,000', value: '₱31,000 - ₱40,000' },
	{ label: '₱41,000 - ₱50,000', value: '₱41,000 - ₱50,000' },
	{ label: '₱51,000 - ₱60,000', value: '₱51,000 - ₱60,000' },
	{ label: '₱61,000 - ₱70,000+', value: '₱61,000 - ₱70,000+' }
];
